import { getTvObject, tv } from '@costar-ui/cosmos';

var selectTV = getTvObject({
  slots: {
    base: 'group relative w-full text-on-base',
    label: 'w-full',
    button: ['w-full', 'items-center', 'text-left', 'px-2 py-1', 'border-transparent', 'hover:border-hover', 'hover:bg-transparent', 'pressed:bg-transparent', 'pressed:border-focus', 'focus:border-focus', 'focus-visible:border-focus', 'disabled:bg-action-disabled', 'disabled:text-on-action-disabled', 'disabled:border-disabled'],
    subText: 'w-full text-neutral-strong',
    listBox: 'max-h-[400px] w-full font-sans',
    gridListItem: '',
    chevron: 'text-neutral-strong'
  },
  variants: {
    variant: {
      outlined: {
        base: 'text-p-16',
        button: 'h-8 border-action-neutral hover:bg-action-base pressed:bg-action-base',
        //height 32px
        listBox: 'text-p-16',
        gridListItem: 'min-h-8 px-2 py-1.5'
      },
      ghost: {
        base: 'text-p-16',
        button: 'h-8 text-p-16',
        // height 32px
        listBox: 'text-p-16',
        gridListItem: 'min-h-8 px-2 py-1.5'
      },
      blueGhost: {
        base: 'text-p-16',
        button: 'h-8 border-none p-0 text-p-16 text-primary hover:text-primary pressed:text-primary',
        // height 32px
        listBox: 'text-p-16',
        gridListItem: 'min-h-8 px-2 py-1.5',
        chevron: 'text-primary'
      },
      'outlined-sm': {
        base: 'text-p-14',
        button: 'h-6 border-action-neutral bg-action-base px-2 py-1 text-p-14 hover:bg-action-base pressed:bg-action-base',
        //height 24px
        listBox: 'text-p-14',
        gridListItem: 'min-h-6 px-2 py-1'
      },
      'ghost-sm': {
        base: 'text-p-14',
        button: 'h-6 px-2 py-1 text-p-14',
        //height 24px
        listBox: 'text-p-14',
        gridListItem: 'min-h-6 px-2 py-1'
      },
      'ghost-xs': {
        base: 'text-p-12',
        button: 'h-5 px-2 py-0.5 text-p-12',
        //height 20px
        listBox: 'text-p-12',
        gridListItem: 'min-h-5 px-2 py-0.5'
      }
    },
    layout: {
      grid: {
        base: 'flex flex-col gap-1'
      },
      relative: {
        label: 'absolute translate-y-[calc(-100%_-_0.25rem)] leading-5',
        subText: 'absolute bottom-0 translate-y-[calc(100%_+_0.25rem)]'
      }
    },
    screenReaderOnly: {
      "true": {
        label: 'sr-only',
        subText: 'sr-only'
      }
    },
    isDisabled: {
      "false": {
        base: 'group-disabled:text-action-disabled'
      }
    }
  }
});
var base = tv(selectTV);
var selectStyles = {
  base: base
};

export { selectStyles, selectTV };
//# sourceMappingURL=select.styles.esm.js.map
